import { EnergyConfig } from '@_models/vehicleInfo/vehicleConfig/energy-config.model';
import { EnergyConsumption } from '@_models/vehicleInfo/energyUsage/energy-consumption.model';
import { Financials } from '@_models/vehicleCost/financials/financials.model';
import { EnergyCost } from '@_models/vehicleCost/energyCost/energy-cost.model';
import { IncentivesTaxe } from '@_models/vehicleCost/incentives/incentives-taxe.model';
import { TransportCost } from '@_models/vehicleCost/transport/transport-cost.model';

export class EnergySessionStorage {
	type: string;
	energyConfig!: EnergyConfig;
	energyUsage!: EnergyConsumption;
	financials: Financials;
	energyCost!: EnergyCost;
	energyIncentivesTaxe!: IncentivesTaxe;
	transportCost!: TransportCost;
}
